import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {PersonalInformationComponent} from "./components/personal-information.component";


const routes = [{
  path: "personal-information",
  component: PersonalInformationComponent,
  canActivate: [CanActivateViaAuthGuard]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PersonalInformationRoutingModule {
}
